import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Phone } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-slate-900 relative" data-id="element-1598">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1599">
        <div className="max-w-5xl mx-auto bg-slate-800/50 rounded-3xl border border-slate-700 overflow-hidden flex flex-col md:flex-row" data-id="element-1600">
          {/* Contact Info */}
          <div className="md:w-2/5 bg-gradient-to-br from-fox-600 to-fox-800 p-10 text-white relative overflow-hidden" data-id="element-1601">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-1602" />

            <h3 className="text-3xl font-heading font-bold mb-2 relative z-10" data-id="element-1603">
              Get in touch
            </h3>
            <p className="text-fox-100 mb-10 relative z-10" data-id="element-1604">
              We'd love to hear from you. Our friendly team is always here to
              chat.
            </p>

            <div className="space-y-6 relative z-10" data-id="element-1605">
              <div className="flex items-center gap-4" data-id="element-1606">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0" data-id="element-1607">
                  <Mail size={20} data-id="element-1608" />
                </div>
                <div data-id="element-1609">
                  <p className="text-sm text-fox-200" data-id="element-1610">Email us</p>
                  <p className="font-medium" data-id="element-1611">support@foxlinehosting.com</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1612">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0" data-id="element-1613">
                  <Phone size={20} data-id="element-1614" />
                </div>
                <div data-id="element-1615">
                  <p className="text-sm text-fox-200" data-id="element-1616">Call us</p>
                  <p className="font-medium" data-id="element-1617">+1 (555) 123-4567</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1618">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0" data-id="element-1619">
                  <MapPin size={20} data-id="element-1620" />
                </div>
                <div data-id="element-1621">
                  <p className="text-sm text-fox-200" data-id="element-1622">Office</p>
                  <p className="font-medium" data-id="element-1623">
                    123 Fox Den Way
                    <br data-id="element-1624" />
                    Forest City, FC 90210
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:w-3/5 p-10 bg-slate-900" data-id="element-1625">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-1626">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1627">
                <div className="space-y-2" data-id="element-1628">
                  <label className="text-sm font-medium text-slate-300" data-id="element-1629">
                    First Name
                  </label>
                  <input type="text" className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors" placeholder="John" data-id="element-1630" />
                </div>
                <div className="space-y-2" data-id="element-1631">
                  <label className="text-sm font-medium text-slate-300" data-id="element-1632">
                    Last Name
                  </label>
                  <input type="text" className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors" placeholder="Doe" data-id="element-1633" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-1634">
                <label className="text-sm font-medium text-slate-300" data-id="element-1635">
                  Email
                </label>
                <input type="email" className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors" placeholder="john@example.com" data-id="element-1636" />
              </div>

              <div className="space-y-2" data-id="element-1637">
                <label className="text-sm font-medium text-slate-300" data-id="element-1638">
                  Message
                </label>
                <textarea rows={4} className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors resize-none" placeholder="How can we help you?" data-id="element-1639"></textarea>
              </div>

              <button className="w-full bg-fox-600 hover:bg-fox-500 text-white font-medium py-3 rounded-lg transition-colors" data-id="element-1640">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}